import React, { useEffect, useState } from "react";
import axios from "axios";
import { message } from "antd";
// import "../Styles/PostGPSRouter.css";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Paper,
  Grid,
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  Fade,
  Slide,
  Switch,
  FormControlLabel,
} from "@mui/material";
import { Add, Refresh, Cancel } from "@mui/icons-material";

const PostRouter = () => {
  const navigate = useNavigate();

  const [code, setCode] = useState("");
  const [gpsId, setGpsId] = useState("");
  const [gpsList, setGpsList] = useState([]);
  const [loadingGps, setLoadingGps] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [status, setStatus] = useState(0); // 0 = Active, 1 = Completed

  useEffect(() => {
    const fetchGps = async () => {
      setLoadingGps(true);
      try {
        const response = await axios.get(
          `https://uktomars.co.uk/api/gps-device`
        );
        setGpsList(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error("Error fetching GPS devices:", error);
        message.error("Failed to load GPS devices");
      } finally {
        setLoadingGps(false);
      }
    };
    fetchGps();
  }, []);

  const handleReset = () => {
    setCode("");
    setGpsId("");
    setStatus(0);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!code.trim()) {
      message.warning("Please enter code");
      return;
    }
    if (!gpsId) {
      message.warning("Please select GPS id");
      return;
    }

    setSubmitting(true);
    try {
      const formData = new FormData();
      formData.append("code", code.trim());
      formData.append("gps_id", gpsId);
      formData.append("status", String(status));

      const res = await fetch("https://uktomars.co.uk/api/posts", {
        method: "POST",
        body: formData,
      });
      if (!res.ok) {
        throw new Error(`HTTP error! Status: ${res.status}`);
      }
      // eslint-disable-next-line no-unused-vars
      const data = await res.json();
      message.success("Form submitted successfully");
      navigate("/PostGetRouter");
    } catch (error) {
      console.error("Error:", error);
      message.error("Failed to submit form. Please try again later.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Fade in={true} timeout={500}>
      <Box sx={{ maxWidth: 1000, mx: "auto", my: 5, px: 2 }}>
        <Slide direction="up" in={true} timeout={400}>
          <Paper elevation={6} sx={{ p: { xs: 2, md: 4 }, borderRadius: 3 }}>
            <Box component="form" onSubmit={handleSubmit}>
              <Box sx={{ textAlign: "center", mb: 3 }}>
                <Typography variant="h5" sx={{ fontWeight: 700 }}>
                  Creates a new post for tracking.
                </Typography>
              </Box>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <TextField
                      label="Code GPS"
                      placeholder="code"
                      value={code}
                      onChange={(e) => setCode(e.target.value)}
                      required
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 2,
                        },
                      }}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <Select
                      displayEmpty
                      value={gpsId}
                      onChange={(e) => setGpsId(e.target.value)}
                      sx={{
                        "& .MuiSelect-select": { py: 1.2 },
                        borderRadius: 2,
                      }}
                    >
                      <MenuItem value="" disabled>
                        <em>GPS id</em>
                      </MenuItem>
                      {loadingGps ? (
                        <MenuItem disabled>Loading...</MenuItem>
                      ) : (
                        gpsList.map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.id}
                          </MenuItem>
                        ))
                      )}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={Number(status) === 0}
                        onChange={(e) => setStatus(e.target.checked ? 0 : 1)}
                        color="success"
                      />
                    }
                    label={Number(status) === 0 ? "Active" : "Completed"}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Box
                    sx={{ display: "flex", gap: 2, justifyContent: "center" }}
                  >
                    <Button
                      variant="outlined"
                      onClick={handleReset}
                      startIcon={<Refresh />}
                    >
                      Reset
                    </Button>
                    <Button
                      variant="outlined"
                      color="error"
                      onClick={() => navigate("/PostGetRouter")}
                      startIcon={<Cancel />}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      variant="contained"
                      startIcon={<Add />}
                      disabled={submitting}
                    >
                      {submitting ? "Submitting..." : "Submit"}
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Paper>
        </Slide>
      </Box>
    </Fade>
  );
};

export default PostRouter;
